import React from "react";
import { Box, Button, Typography } from "@mui/joy";
import { theme } from "styles/theme";

interface ConflictBannerProps {
  reason: "overlap" | "length_mismatch";
  conflictBlockIndexes: number[];
  onAcceptAgent: () => void;
  onKeepMine: () => void;
}

// agent 와 user 가 같은 블록(또는 블록 개수)을 동시에 수정해 자동 머지가 불가한 상황.
// v1 은 whole-task 2-button (per-block accept 는 v2). banner 는 workspace 상단에 sticky.
export function ConflictBanner({
  reason,
  conflictBlockIndexes,
  onAcceptAgent,
  onKeepMine,
}: ConflictBannerProps) {
  const summary =
    reason === "overlap"
      ? `에이전트가 동시에 수정한 블록이 있습니다 (#${conflictBlockIndexes
          .map((i) => i + 1)
          .join(", #")})`
      : "에이전트가 블록 개수를 변경했습니다 — 자동 머지 불가";
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        px: "12px",
        py: "8px",
        borderBottom: `1px solid rgba(245, 158, 11, 0.4)`,
        backgroundColor: "rgba(245, 158, 11, 0.10)",
      }}
    >
      <Typography
        level="body-xs"
        sx={{
          flex: 1,
          color: "#92400e",
          fontWeight: 600,
          fontSize: "12px",
        }}
      >
        {summary}
      </Typography>
      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        onClick={onKeepMine}
        sx={{ fontSize: "11px", minHeight: "26px" }}
      >
        내 편집 유지
      </Button>
      <Button
        size="sm"
        variant="Solid"
        color="warning"
        onClick={onAcceptAgent}
        sx={{
          fontSize: "11px",
          minHeight: "26px",
          backgroundColor: "#f59e0b",
        }}
      >
        에이전트 적용
      </Button>
      <Box
        sx={{ width: "1px", height: "16px", backgroundColor: "transparent" }}
      />
      <Box
        component="span"
        sx={{
          color: theme.vars.palette.Content.Weak,
          fontSize: "10px",
        }}
      >
        (선택 후 같은 블록은 둘 중 하나만 남습니다)
      </Box>
    </Box>
  );
}
